// extracted by mini-css-extract-plugin
export var icon = "_42-1";
export var subtext = "_42-0";